import styles from "components/sections/TextBanner.module.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import classNames from "classnames";
import {useEffect, useRef} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Autoplay, Navigation, Pagination} from "swiper";
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import Link from "next/link";
import {swiperCustomAnimation} from "common/utils";


SwiperCore.use([Navigation, Pagination, Autoplay]);

const BannerContent = ({banner}) => {
    return (
        <>
            <div className={styles.textContainer}>
                <span>{banner.text}</span>
            </div>
        </>
    )
}


export default function TextBanner(props) {
    const {banners, onClick} = props;

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const swiperRef = useRef();
    const swipedRef = useRef(0);

    const onTouchEnd = (swiper) => {
        swipedRef.current = Date.now();
    };

    const onSlideChange = (swiper) => {
        if (Date.now() - swipedRef.current < 1000) {
            typeof mixpanel !== 'undefined' && mixpanel.track(
                'MainPageMainBannerSwipe',
                {
                    activeIndex: swiper.activeIndex,
                    nextBannerName: banners[swiper.activeIndex]?.text,
                }
            );
        }
    }

    const timerRef = useRef(null);

    const swiperAutoPlay = () => {
        if (banners && banners.length <= 1) return;
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            if (swiperRef.current?.swiper) {
                swiperRef.current.swiper.slideNext();
            }
            swiperAutoPlay();
        }, 3000);
    }

    const stopAutoPlay = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }

    const resumeAutoPlay = () => {
        swiperAutoPlay();
    }

    useEffect(() => {
        swiperAutoPlay();
    }, []);

    useEffect(() => {
        if (!swiperRef.current) return;
        swiperRef.current.addEventListener('mouseenter', stopAutoPlay);
        swiperRef.current.addEventListener('mouseleave', resumeAutoPlay);
        return () => {
            swiperRef.current.removeEventListener('mouseenter', stopAutoPlay);
            swiperRef.current.removeEventListener('mouseleave', resumeAutoPlay);
        }
    }, [swiperRef.current]);

    return (
        <div className={classNames(styles.root)}>
            <div className={styles.swiperWrapper}>
                {
                    banners && banners.length > 0 ?
                        <Swiper
                            className={styles.swiper}
                            ref={swiperRef}
                            loop={banners && (banners.length > 1)}
                            onSetTranslate={swiperCustomAnimation}
                            onInit={(swiper) => {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }}
                            onSlideChangeTransitionEnd={(swiper) => {
                                swiperAutoPlay();
                            }}
                            spaceBetween={0}
                            slidesPerView={1}
                            threshold={20}
                            onSlideChange={onSlideChange}
                            onTouchEnd={onTouchEnd}
                        >
                            {
                                banners.map((banner, idx) => {
                                    return (
                                        <SwiperSlide key={idx}>
                                            {
                                                banner.link ?
                                                    <Link href={banner.link || ''}>
                                                        <a className={styles.bannerItem}
                                                           onClick={() => onClick(banner, idx)}>
                                                            <BannerContent banner={banner}/>
                                                        </a>
                                                    </Link> :
                                                    <div className={styles.bannerItem}
                                                         onClick={() => onClick(banner, idx)}>
                                                        <BannerContent banner={banner}/>
                                                    </div>
                                            }
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                        :
                        <div className={classNames(styles.root)}/>
                }
            </div>
        </div>
    )
}
